import { Incident } from '@collector/sportsapi-client'
import {
  AdditionalInfoSecondaryAssistantProperties,
  IncidentSubParticipantProperties,
} from '@desktop/views/Relation/Sports/configuration'
import { IncidentPlayerOptionValue } from '@desktop/views/Relation/types'

export type SubParticipantValue =
  Omit<IncidentPlayerOptionValue, 'teamId' | 'lineupId'> | undefined

export function isSubParticipantOption(
  subParticipantValue: SubParticipantValue,
  option: Omit<IncidentPlayerOptionValue, 'teamId' | 'lineupId'>,
): boolean {
  if (subParticipantValue?.id) {
    return subParticipantValue.id === option.id
  }

  return subParticipantValue?.shortName === option.shortName
}

export function getSubparticipantValue(
  shortName: string | null,
  id: number | null,
): SubParticipantValue {
  if (shortName === null && id === null) return undefined

  return {
    shortName,
    id,
  }
}

export function getSubParticipantIdValue(
  incident: Incident,
  propertyId: (
    | IncidentSubParticipantProperties
    | AdditionalInfoSecondaryAssistantProperties
  )['propertyId'],
): number | null {
  if (propertyId === 'secondary_assistant_id') {
    return incident.additional_info?.secondary_assistant_id ?? null
  }

  return incident[propertyId]
}

export function getSubParticipantNameValue(
  incident: Incident,
  propertyId: (
    | IncidentSubParticipantProperties
    | AdditionalInfoSecondaryAssistantProperties
  )['propertyName'],
): string | null {
  if (propertyId === 'secondary_assistant_name') {
    return incident.additional_info?.secondary_assistant_name ?? null
  }

  return incident[propertyId]
}

export function getSubParticipantPathValue(
  incident: Incident,
  {
    propertyName,
    propertyId,
  }:
    | IncidentSubParticipantProperties
    | AdditionalInfoSecondaryAssistantProperties,
): SubParticipantValue {
  return getSubparticipantValue(
    getSubParticipantNameValue(incident, propertyName),
    getSubParticipantIdValue(incident, propertyId),
  )
}
